
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import Constant from "@constant/index.js";
import {$util} from "@util/util.js";
export default class OptionListView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        // console.log('初始数据',this._model);

        this._parentEl = this._model._parent._view._optionBoxEl;
        this._el = null;
    }
    initData() {
      this._model._optionList.map((item,index)=>{
        item.optionnum = 1;
        if(this._model._parent._option){
          this._model._parent._option._data.map((child,i)=>{
            if(child.id == item.code) {
              item.optionStatus = true;
              item.optionnum = child.num;        
            }
          })
        }
      })
    }
    showCodeIcon(item){
      if(!item.optionStatus) {
        if(!item.status){
          return `<i class="iconfont icon-disabled checkbox" code=${item.code}></i>`
        } else {
          return `<i class="iconfont icon-uncheck checkbox" code=${item.code}></i>`
        }
      } else {
        return `<i class="iconfont icon-checked checkbox" code=${item.code}></i>`
      }
      
      // if(item.optionStatus){
      //     return `<i class="iconfont icon-checked checkbox" code=${item.code}></i>`
      // }else{
      //     return `<i class="iconfont icon-uncheck checkbox" code=${item.code}></i>`
      // }
  }

    shixiaoList(item){
      // if(item.status == 0 && (item.stockNum == 0)){
      //     return `<p class="receive_good_num"><span>已赠完</span></p>`
      // }else if(item.status == 0 && (item.stockNum > 0)){
      //     return `<p class="receive_good_num"><span>已失效</span></p>`
      // }else{
      //     return `<p class="receive_good_num">¥${item.productPrice}<span>省¥${item.discountAmount}</span></p>`
      // }
      if(!item.status) {
        return `<p class="receive_good_num"><span style="padding-left:0px;">已失效</span></p>`;
      } else {
        return `<p class="receive_good_num">¥${item.productPrice}<span>省¥${item.discountAmount}</span></p>`
      }
    }
    showCodeAlready(item){
      if(!item.status){
          return `<div class="already_sold_box"></div>`
      }else{
          return ''
      }
     }

     itemStyle(item){
      if(item.optionnum == 1){
        return 'color:#E0E0E0;pointer-events: none;'
      }
      return ''
    }
    // || item.optionnum >= this._model._parent._maxPurchase
    itemStyleAdd(item){
      if(item.optionnum >= item.limitedNumber ||  item.optionnum >= item.stockNum  || item.optionnum >= this._model._parent._count){
        return 'color:#E0E0E0;pointer-events: none;'
      }
      return ''
    }
    itemTitleStork(item){
      if(!item.status) {
        return ''
      }
      if(item.stockNum &&item.limitedNumber){
        if(item.limitedNumber<item.stockNum && item.limitedNumber < this._model._parent._count){
          return `<i >限购${item.limitedNumber}件</i>`
        }else if(item.stockNum  < this._model._parent._count){
          return `<i >库存${item.stockNum}件</i>`
        }
      }
      if(item.stockNum  < this._model._parent._count){
        return `<i >库存${item.stockNum}件</i>`
      }
      if(item.limitedNumber < this._model._parent._count){
        return `<i >限购${item.limitedNumber}件</i>`
      }
     
      return ''
    }
    itemCOunt(item){
      if(!item.status) {
        return ''
      }else{        
        return `<p class="le_num_action">
          <input type="button" style="${this.itemStyle(item)}" tag="optionCount" value="-"  data-code="${item.code}" class="reduce" />
          <input class="num" readonly value="${item.optionnum}" type="text"  />
          
          <input type="button"  style="${this.itemStyleAdd(item)}" data-code="${item.code}" data-limitedNumber="${item.limitedNumber}" data-stockNum="${item.stockNum}"  value="+" class="add" />         
        </p>`
      }
    }
    getItems(category){
      let data = this._model._optionList
        let html = ''
        data.map((item, index) => {
          html += `<div class="clearfix content_item" data-able='${item.status}'>
          <div class="fl item_checkbox" tag="OptionListItem" status=${item.status} code=${item.code}>
          ${this.showCodeIcon(item)}
          
          </div>
          <a href="${item.goodsDetailUrl}" class="fl item_img ${item.status ? '' : 'disable'}">
            <img src="${item.path}" />
            ${this.showCodeAlready(item)}
          </a>
          <div class="fl item_text">
            <a href="${item.goodsDetailUrl}" >
              <p class="receive_good_title ${item.status ? '' : 'disable'}">${item.goodsName}</p>
            </a>
              <div class="receive_good_desc" >
                ${this.shixiaoList(item)}
                ${this.itemCOunt(item)}
              </div>
              <div class ="stock_tips">
                ${this.itemTitleStork(item)}
              </div>
          </div>
          
      </div>`
      })
      return html
    }


    render(){
        this.initData();
        let html = "";
        html += `
          <div class="clearfix receive_content">
          ${this.getItems()}
          </div>
          <div class="service_btn_group" tag="service_btn_group">
            <p>已选择<span tag="onClickOptionSpan"></span>个选件</p>
            <button class="le_btn le_btn_solid confirm" tag='onClickOptionOK'>确定</button>
            <button class="le_btn le_btn_border cancel" tag='onClickOptionCancel' >取消</button>
          </div>
         `;
        // this._el = $(".option_wrapper");
        this.regEvent();
        this._parentEl.html(html);
        // this._el.html(html)
        //每次渲染页面的时候就把选择了几个选件渲染到页面
        let codss = 0;
        this._model._optionList.map((item, indexs) =>{    
          if( item.optionStatus){     
            codss += item.optionnum;
          }
        })
        // console.log(codss)
        this._parentEl.find("[tag=onClickOptionSpan]").html(codss);
        
    }

    regEvent(){
      let that = this;
      this._parentEl.off("click","[tag=OptionListItem]").on("click","[tag=OptionListItem]",function(){
        var iconfontDom = $(this).find('i.iconfont')
        let status = $(this).attr('status')
        let codes = $(this).attr('code')
        if(status == 0){
          if(iconfontDom.hasClass('icon-checked')){
            that._model._optionList.map((items, indexs) =>{
              if(items.code == codes){
                items.optionStatus = false;
              }
            })
            iconfontDom.removeClass('icon-checked').addClass('icon-disabled');
          }
        }else{
          if(iconfontDom.hasClass("icon-uncheck")){
              iconfontDom.removeClass('icon-uncheck').addClass('icon-checked')
          }else{
              iconfontDom.removeClass('icon-checked').addClass('icon-uncheck')
          }     
          that._model._optionList.map((items, indexs) =>{
            if(items.code == codes){
              if(items.optionStatus == undefined){
                items.optionStatus = true
              }else{
                items.optionStatus = !items.optionStatus
              }
            }          
          })              
        }       
        
        let codss = 0
        that._model._optionList.map((items, indexs) =>{         
          if(items.optionStatus){
            codss += items.optionnum
          }
        })         
        that._parentEl.find("[tag=onClickOptionSpan]").html(codss);
       
      })


      // 点击加
      this._parentEl.off("click", ".le_num_action .add").on("click", ".le_num_action .add", function () {
          let stockNum = $(this).attr('data-stockNum');
          let limitedNumber = $(this).attr('data-limitedNumber');
          let count = $(this).siblings('.num').val();
          let goodsCode = $(this).attr('data-code');
          let codss = 0;
           count++;
           $(this).siblings('.reduce').css('pointer-events','auto');
          if(count == stockNum) {
            // 当前到最大库存
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            // $(this).siblings('i').html('库存' + count +'件').show();
          } else if(count == that._model._parent._count) {
            // 当前到主品最大数量
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            // $(this).siblings('i').html('限购' + count+'件').show();
          } else if(count == that._model._parent._maxPurchase) {
            // 当前到限购最大数量
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            // $(this).siblings('i').html('限购' + count + '件').show();
          }
          else if(count == limitedNumber) {
            // 当前到限购最大数量
            $(this).css('color','#E0E0E0');
            $(this).css('pointer-events','none');
            $(this).siblings('i').html('限购' + limitedNumber + '件').show();
          }
          else {
            //每次渲染页面的时候就把选择了几个选件渲染到页面
          }
          $(this).siblings('.num').val(count);
          
          if(count > 1) {
            $(this).siblings('.reduce').css('color','#454545');
          }
          that._model._optionList.map((items, indexs) =>{
            if(items.code == goodsCode){
              items.optionnum = count;
            }       
            if(items.optionStatus){     
              codss += items.optionnum;
            }     
          })    
          //每次渲染页面的时候就把选择了几个选件渲染到页面
          that._parentEl.find("[tag=onClickOptionSpan]").html(codss);   
      })
      // 点击减
      this._parentEl.off("click", ".le_num_action .reduce").on("click", ".le_num_action .reduce", function () {
        // 每次点减号就让加号可以点击
        
        let count = $(this).siblings('.num').val();
        let goodsCode = $(this).attr('data-code');
        let codss = 0;
        count--;
        if(count == 1) {
          $(this).css('color','#E0E0E0');
          count = 1;
          $(this).siblings('.num').val(count);
          $(this).siblings('.add').css('pointer-events','auto');
          $(this).siblings('.add').css('color','#454545');         
        } else if(count > 1) {
          $(this).siblings('.add').css('color','#454545');
          $(this).siblings('.add').css('pointer-events','auto');
          $(this).siblings('i').hide();
          $(this).css('color','#454545');
          $(this).siblings('.num').val(count);          
        }else{
          return ;
        }
       
        that._model._optionList.map((items, indexs) =>{
          if(items.code == goodsCode){
            items.optionnum = count;
          }    
          if(items.optionStatus){     
            codss += items.optionnum;
          }             
        }) 
        //每次渲染页面的时候就把选择了几个选件渲染到页面
        that._parentEl.find("[tag=onClickOptionSpan]").html(codss);        
        
      })
      // 点击确定
      this._parentEl.off("click","[tag=onClickOptionOK]").on("click","[tag=onClickOptionOK]",function(){    
        
        var codes = [];
        for(var i=0; i < that._model._optionList.length;i++){      
          if(that._model._optionList[i].status == '0' && that._model._optionList[i].optionStatus) {             
            Alert.showTip('请取消失效商品');
            // 包含失效商品
            return false;
          }
          if(that._model._optionList[i].optionStatus){
            codes.push({
                gcode: that._model._optionList[i].code,
                num: that._model._optionList[i].optionnum
            })
          }
        }
        that._model._parent.modifyItemFromCart({opsType:1,content:JSON.stringify(codes)}).then(()=>{
          if(codes.length == 0) {
            $(that._model._parent._view._extraBoxEl.find('div.option')).hide();
          }
          that._model._view._parentEl.hide();
          var _li =  that._model._parent._view._el.find('li.option_wrapper');
          var iconfontDom =  _li.find('[tag=onClickChOption] i.iconfont');
          _li.removeClass("active");
          iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down');

        }).catch(err =>{
          Alert.showTip(err);
        });
     
      })
      // 选择选件取消
      this._parentEl.off("click","[tag='onClickOptionCancel']").on("click","[tag='onClickOptionCancel']",function(){
        that._model._view._parentEl.hide();
        var _li =  that._model._parent._view._el.find('li.option_wrapper');
        var iconfontDom =  _li.find('[tag=onClickChOption] i.iconfont');
        _li.removeClass("active");
        iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down');
           
      })
    }   
}

